export let EndCapStyle;(function(C){C[C["CAP_ROUND"]=1]="CAP_ROUND";C[C["CAP_BUTT"]=2]="CAP_BUTT"})(EndCapStyle||(EndCapStyle={}));